export class VehicleManagementCollections {
  static ModuleName = 'vehicle-management';

  static vehicleMakes = `${VehicleManagementCollections.ModuleName}/vehicle-makes`;
  static vehicleMake(vehicleMakeId: string) {
    return `${VehicleManagementCollections.vehicleMakes}/${vehicleMakeId}`;
  }

  static vehicleManufacturers = `${VehicleManagementCollections.ModuleName}/vehicle-manufacturers`;
  static vehicleManufacturer(vehicleManufacturerId: string) {
    return `${VehicleManagementCollections.vehicleManufacturers}/${vehicleManufacturerId}`;
  }

  static vehicleModels = `${VehicleManagementCollections.ModuleName}/vehicle-models`;
  static vehicleModel(vehicleModelId: string) {
    return `${VehicleManagementCollections.vehicleModels}/${vehicleModelId}`;
  }

  static vehicles = `${VehicleManagementCollections.ModuleName}/vehicles`;
  static vehicle(vehicleId: string) {
    return `${VehicleManagementCollections.vehicles}/${vehicleId}`;
  }

  static publicVehicles = `${VehicleManagementCollections.ModuleName}/public-vehicles`;

  static vehicleExistence = `${VehicleManagementCollections.ModuleName}/end-users/vehicles/existence`;

  static vehicleEligibleAccounts(vehicleId: string) {
    return `${VehicleManagementCollections.vehicle(vehicleId)}/eligible-accounts`;
  }

  static vehicleEligibleDrivers(vehicleId: string) {
    return `${VehicleManagementCollections.vehicle(vehicleId)}/drivers`;
  }
  static vehicleBodyTypes() {
    return `${VehicleManagementCollections.vehicles}/lookups`;
  }

  static vehicleBodyTypesPublic() {
    return `${VehicleManagementCollections.publicVehicles}/lookups/vehicle-types`;
  }

  static vehicleServiceRecords(vehicleId: string) {
    return `${VehicleManagementCollections.vehicle(vehicleId)}/service-records`;
  }

  static vehiclePlateLicenseTypes = `${VehicleManagementCollections.ModuleName}/vehicle-plate-license-types`;
  static vehiclePlateLicenseType(plateLicenseTypeId: string) {
    return `${VehicleManagementCollections.vehiclePlateLicenseTypes}/${plateLicenseTypeId}`;
  }

  static vehiclePlateLicenseTypesPublic = `${VehicleManagementCollections.ModuleName}/public-vehicle-plate-license-types`;
}
